// Shared scenario/candidate purpose + process constants.
//
// Process selection is PURPOSE-DEPENDENT: the superadmin/admin picks a purpose
// first, then the process dropdown is populated from the list for that purpose.
// Values are stored lowercase/underscored (used as the Mongo collection name
// `process_<value>`); labels are the human-friendly display text.

// Purposes that a create/edit form or candidate form may STORE.
export const PURPOSES = ['training', 'hiring'];

// Purposes the Scenario Management list/filter control may SELECT (adds the
// read-only 'unclassified' filter for legacy un-backfilled documents).
export const FILTER_PURPOSES = ['training', 'hiring', 'unclassified'];

export const PURPOSE_LABELS = {
  training: 'Training',
  hiring: 'Hiring',
  unclassified: 'Unclassified',
};

// Friendly labels for every process slug used across both purposes (+ legacy).
export const PROCESS_LABELS = {
  mobile_billing: 'Mobile Billing',
  home_billing: 'Home Billing',
  home_tech: 'Home Tech',
  sales: 'Sales',
  new_sales: 'New Sales',
  broadband_sales: 'Broadband Sales',
  mobile_sales: 'Mobile Sales',
  dfm: 'DFM',
  // Legacy processes — kept selectable so pre-existing data stays reachable.
  billing: 'Billing (Legacy)',
};

// Purpose -> ordered list of selectable process slugs.
// Hiring and Training have different process sets. "Legacy" processes
// (old flat slugs from before the purpose feature) are appended to BOTH so
// existing data under process_billing / process_sales remains reachable for
// viewing, editing, and reclassifying.
export const LEGACY_PROCESSES = ['billing'];

export const PROCESSES_BY_PURPOSE = {
  hiring: ['mobile_billing', 'home_billing', 'home_tech', 'sales', ...LEGACY_PROCESSES],
  training: [
    'mobile_billing',
    'home_billing',
    'home_tech',
    'new_sales',
    'broadband_sales',
    'mobile_sales',
    'dfm',
    ...LEGACY_PROCESSES,
  ],
};

// The full set of every valid process slug across all purposes (+ legacy),
// useful for validation and stale-value checks.
export const ALL_PROCESSES = Array.from(
  new Set([...PROCESSES_BY_PURPOSE.hiring, ...PROCESSES_BY_PURPOSE.training])
);

// Return the selectable process slugs for a given purpose.
// For the read-only 'unclassified' filter we expose every process so a
// superadmin can hunt for legacy/un-backfilled docs in any collection.
export function processesForPurpose(purpose) {
  const p = (purpose || '').toLowerCase();
  if (p === 'unclassified') return ALL_PROCESSES;
  return PROCESSES_BY_PURPOSE[p] || [];
}